import { RoundedCheckIcon } from "../../../assets/icons";


export const SignupInterestCheckbox = ({
  value,
  onChange,
  id,
  name,
  children,
}) => {

  return (
    <>
      <input
        type="checkbox"
        className="sr-only peer"
        name={name}
        id={id}
        checked={value}
        onChange={onChange}
      />
      <label
        htmlFor={id}
        className={`cursor-pointer w-fit px-2 py-1.5 rounded-[0.8rem] border peer-focus-visible:ring-2 peer-focus-visible:ring-secondary/60 peer-focus-visible:ring-offset-2 ${value ? 'border-secondary bg-secondary text-primary' : 'border-mediumgrey bg-transparent text-darkgrey'} text-sm vertical-center gap-1.5 font-sans select-none`}>
        <RoundedCheckIcon color={value ? '#082746' : '#A6A6A7'} />
        {children}
      </label>
    </>
  );
}